import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const BACKEND_URL = "https://vd.aiteacha.com/api/";
const FLUTTERWAVE_PUBLIC = "FLWPUBK-b2c02bd79a3fe83eaa70fa2e53f69432-X";
export { BACKEND_URL, FLUTTERWAVE_PUBLIC };
